import React from 'react';
import { CheckCircle2, Shirt, Clock, AlertCircle, Users } from 'lucide-react';
import { CAMP_SEASON, WHAT_TO_BRING } from './summerCampContent';
export function SummerCampBringAndPickup() {
  return <section className="py-24 bg-off-white" data-id="element-3138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3139">
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-3140">
          <div data-id="element-3141">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3142">
              What Campers Should Bring
            </h2>
            <div className="bg-paper rounded-2xl p-8 border border-subtle-gray" data-id="element-3143">
              <ul className="flex flex-col gap-4" data-id="element-3144">
                {WHAT_TO_BRING.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-3145">
                    <div className="w-8 h-8 bg-storm-red rounded-lg flex items-center justify-center shrink-0" data-id="element-3146">
                      <CheckCircle2 className="w-5 h-5 text-white" data-id="element-3147" />
                    </div>
                    <span className="text-ink font-bold" data-id="element-3148">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-6 pt-6 border-t border-subtle-gray flex items-start gap-3" data-id="element-3149">
                <Shirt className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-3150" />
                <p className="text-sm text-gray-warm" data-id="element-3151">
                  <span className="font-bold text-ink" data-id="element-3152">
                    No need to bring a uniform.
                  </span>{' '}
                  a Storm Taekwondo camp shirt is included for every camper.
                </p>
              </div>
            </div>
          </div>

          <div data-id="element-3153">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3154">Drop-Off & Pickup</h2>
            <div className="flex flex-col gap-4" data-id="element-3155">
              <div className="bg-ink text-white p-6 rounded-2xl" data-id="element-3156">
                <div className="flex items-center gap-3 mb-2" data-id="element-3157">
                  <Clock className="w-6 h-6 text-storm-red" data-id="element-3158" />
                  <h3 className="text-xl text-white m-0" data-id="element-3159">Camp Hours</h3>
                </div>
                <p className="text-gray-warm" data-id="element-3160">{CAMP_SEASON.hours}</p>
              </div>

              <div className="bg-storm-red text-white p-6 rounded-2xl" data-id="element-3161">
                <div className="flex items-center gap-3 mb-2" data-id="element-3162">
                  <AlertCircle className="w-6 h-6 text-white" data-id="element-3163" />
                  <h3 className="text-xl text-white m-0" data-id="element-3164">No Early Drop-Off</h3>
                </div>
                <p className="text-white/90" data-id="element-3165">
                  Please arrive at the start of the camp day. Early drop-off is
                  not available.
                </p>
              </div>

              <div className="bg-charcoal text-white p-6 rounded-2xl" data-id="element-3166">
                <div className="flex items-center gap-3 mb-2" data-id="element-3167">
                  <CheckCircle2 className="w-6 h-6 text-storm-red" data-id="element-3168" />
                  <h3 className="text-xl text-white m-0" data-id="element-3169">Late Pickup Is OK</h3>
                </div>
                <p className="text-gray-warm" data-id="element-3170">
                  Running late? No problem. Kids can hang out until parents
                  arrive. Regular Storm classes start immediately after camp.
                </p>
              </div>

              <div className="bg-ink text-white p-6 rounded-2xl" data-id="element-3171">
                <div className="flex items-center gap-3 mb-2" data-id="element-3172">
                  <Users className="w-6 h-6 text-storm-red" data-id="element-3173" />
                  <h3 className="text-xl text-white m-0" data-id="element-3174">{CAMP_SEASON.ages}</h3>
                </div>
                <p className="text-gray-warm" data-id="element-3175">
                  Camp is open to all kids ages 6 and up. No Taekwondo
                  experience needed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}